import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import {
  Col,
  Row,
  Form,
  FormGroup,
  Input,
  Label,
  Card,
  Button,
} from "reactstrap";
import { toast } from "react-toastify";
import axios from "axios";
import { baseUrl } from "../../../../Utils/Baseurl/Baseurl";
import { Btn, H2, P } from "../../../../AbstractElements";
import api from "../../../../services/api";
interface CertificateFormData {
  medicinename: string;
  description: string;
  quotation: FileList | null;
  gmpcertificate: FileList | null;
  productpackagecoverorinsert: FileList | null;
  // batchtestingreport: FileList | null;
  // otherdocuments: FileList | null;
  analysiscertificate: FileList | null;
  otherdetails: File[] | null;
}
type CertificateType = {
  path: string;
  filestatus: string;
  filename?: string; // Optional filename property
};


interface ExistingData {
  medicinename: string;
  description: string;
  certificates: Record<
    string,
    { path: string; filestatus: string } | undefined
  >;
  VerificationStatus: number;
  status: number;
  finalstatus: number;
  id: string;
  indentform: string;
  otherdetails?: { path: string; filestatus: string }[];
}

export default function MedicineReupload() {
  const { tokenid } = useParams<{ tokenid: string }>();
  const navigate = useNavigate();
  const [rejectionstatus, setRejectionstatus] = useState("");
  const [finalstatus, setFinalStatus] = useState("");
  const [status, setStatus] = useState("");
  const [rejectionReason, setRejectionReason] = useState("");
  const [rejectionReasons, setRejectionReasons] = useState("");

  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<CertificateFormData>();

  const [existingData, setExistingData] = useState<ExistingData | null>(null);
  const [canEdit, setCanEdit] = useState(false);
  const [contents, setContents] = useState<
    { name: string; quantity: string }[]
  >([]);
  const [otherDetails, setOtherDetails] = useState<
    { path: string; filestatus: string }[]
  >([]);

  useEffect(() => {
    if (!tokenid) return;
    const fetchDetails = async () => {
      try {
        const response = await api.get(
          `${baseUrl}medicinedetails/certificates/${tokenid}`
        );
        const data = response.data;
        console.log("Fetched Data:", data);
        setExistingData(data);
        setRejectionReason(response.data.rejectionReason);
        setStatus(response.data.status);
        setFinalStatus(response.data.finalstatus);
        setRejectionstatus(response.data.rejectionstatus);

        setContents(response.data.contents ? response.data.contents.reverse() : []);

        setOtherDetails(Array.isArray(data.otherdetails) ? data.otherdetails : []); // Ensure it's an array


        setRejectionReasons(
          Array.isArray(response.data?.rejectionDetails)
            ? response.data.rejectionDetails
            : []
        );

        if (
          (data.VerificationStatus === 1 &&
            data.status === 2 &&
            data.finalstatus === 0) ||
          (data.VerificationStatus === 1 &&
            data.status === 1 &&
            data.finalstatus === 2)
        ) {
          setCanEdit(true);
        } else {
          setCanEdit(false);
        }

        setValue("medicinename", data?.medicinename || "");
        setValue("description", data?.description || "");
      } catch (error) {
        console.error("Error fetching medicine details:", error);
      }
    };

    fetchDetails();
  }, [tokenid, setValue]);

  const onSubmit = async (data: CertificateFormData) => {
    if (!existingData || !existingData.id) {
      toast.error("Medicine details not found. Please try again.");
      return;
    }

    // Creating a new FormData object
    const formData = new FormData();

    // Append the existing fields (medicinename and description) to the form data
    formData.append("medicinename", existingData.medicinename || "");
    formData.append("description", existingData.description || "");
    formData.append("contents", JSON.stringify(contents));

    // Apply conditional updates for status and finalstatus
    if (
      existingData.VerificationStatus === 1 &&
      existingData.status === 2 &&
      existingData.finalstatus === 0
    ) {
      formData.append("status", "0");
    }
    if (
      existingData.VerificationStatus === 1 &&
      existingData.status === 1 &&
      existingData.finalstatus === 2
    ) {
      formData.append("finalstatus", "0");
    }

    // Loop through the data and append files if they exist
    Object.entries(data).forEach(([key, value]) => {
      if (value instanceof FileList && value.length > 0) {
        formData.append(key, value[0]);
      }
    });

    try {
      // API call to update the details
      console.log("Updating ID:", existingData.id); // Debugging
      const response = await api.post(
        `${baseUrl}medicinedetails/updatedetails/${existingData.id}`, // Correct API endpoint to handle updates
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      // Handle success response
      toast.success("Details updated successfully!");
      setTimeout(
        () => navigate(`${process.env.PUBLIC_URL}/medicinetable`),
        2000
      ); // Navigate after successful update
    } catch (error) {
      // Handle error response
      console.error("Error updating details:", error);
      toast.error("Failed to update details. Please try again.");
    }
  };

  const labelMap: Record<string, string> = {
    gmpcertificate: "GMP Certificate",
    analysiscertificate: "Analysis Certificate",
    quotation: "Quotation",
    productpackagecoverorinsert: "Product Package Cover / Insert",
    // batchtestingreport: "Batch Testing Report",
    // otherdocuments: "Other Documents",
  };

  const addContent = () => {
    setContents([{ name: "", quantity: "" }, ...contents]); // Insert at the beginning
  };
  

  const updateContent = (
    index: number,
    field: "name" | "quantity",
    value: string
  ) => {
    const updatedContents = [...contents];
    updatedContents[index][field] = value;
    setContents(updatedContents);
  };

  const removeContent = (index: number) => {
    setContents(contents.filter((_, i) => i !== index));
  };

  return (
    <>
      <Col sm={12}>
        <Card>
          <div className="certificates p-5">
            <Form className="theme-form" onSubmit={handleSubmit(onSubmit)}>
              <H2 className="text-center"> Medical Files</H2>
              <P className="text-center">
                {"Upload the related files of the medicine"}
              </P>

              <FormGroup>
                <Row className="align-items-center">
                  <Col md={4}>
                    <Label className="mb-0">Medicine Name</Label>
                  </Col>
                  <Col md={8}>
                    <Controller
                      name="medicinename"
                      control={control}
                      render={({ field }) => (
                        <Input type="text" {...field} disabled />
                      )}
                    />
                  </Col>
                </Row>
              </FormGroup>

              {/* Content section */}

              <FormGroup>
                <Row className="align-items-center">
                  <Col md={4}>
                    <Label className="mb-0">Content Details </Label>
                  </Col>
                </Row>
              </FormGroup>

              {contents.length > 0 ? (
                contents.map((content, index) => (
                  <FormGroup key={index}>
                    <Row className="align-items-center">
                      <Col md={4}></Col>
                      <Col md={4}>
                        <Input
                          type="text"
                          placeholder="Content Name"
                          readOnly
                          value={content.name} // Prefill with default value if empty
                          onChange={(e) =>
                            updateContent(index, "name", e.target.value)
                          }
                        />
                      </Col>
                      <Col md={3}>
                        <Input
                          type="text"
                          placeholder="Quantity (gms)"
                          readOnly
                          value={content.quantity} // Prefill with a default quantity
                          onChange={(e) =>
                            updateContent(index, "quantity", e.target.value)
                          }
                        />
                      </Col>
                    </Row>
                  </FormGroup>
                ))
              ) : (
                <p className="text-center text-muted">
                  No content details added.
                </p>
              )}

              <FormGroup>
                <Row className="align-items-center">
                  <Col md={4}>
                    <Label className="mb-0">Description</Label>
                  </Col>
                  <Col md={8}>
                    <Controller
                      name="description"
                      control={control}
                      render={({ field }) => (
                        <textarea
                          {...field}
                          className="form-control"
                          rows={4}
                          readOnly
                        />
                      )}
                    />
                  </Col>
                </Row>
              </FormGroup>
              {Object.entries(labelMap).map(([key, label]) => {
  const certificateData = existingData?.certificates?.[key] as CertificateType | undefined; // Ensure correct typing
  const filePath = certificateData?.path;
  const filename = certificateData?.filename || "View File"; // Fallback if filename is missing
  const fileStatus = certificateData?.filestatus;

  let fileStatusLabel = "No documents"; // Default status

  if (fileStatus === "1" || fileStatus === "3") {
    fileStatusLabel = "✅ Approved";
  } else if (fileStatus === "2") {
    fileStatusLabel = "❌ Rejected";
  } else if (fileStatus === "0") {
    fileStatusLabel = "⏳ Not Verified";
  }

  return (
    <FormGroup key={key}>
      <Row className="align-items-center">
        <Col md={4}>
          <Label className="mb-0">{label}</Label>
        </Col>
        <Col md={8} className="d-flex justify-content-between align-items-center">
          {filePath ? (
            <>
              <a href={`${baseUrl}${filePath}`} target="_blank" rel="noopener noreferrer">
                {filename}
              </a>
              <br />
              <span style={{ fontWeight: "bold" }}>{fileStatusLabel}</span>
            </>
          ) : (
            <span>No file uploaded</span>
          )}
        </Col>
      </Row>
    </FormGroup>
  );
})}


              {/* Other Details (Supporting Documents) */}
              <FormGroup>
                <Row className="align-items-center">
                  <Col md={4}>
                    <Label className="mb-0">Supporting Documents</Label>
                  </Col>
                  <Col md={8}>
                    <Controller
                      name="otherdetails"
                      control={control}
                      render={({ field: { onChange, value, ...field } }) => {
                        const fileArray = Array.isArray(value) ? value : []; // Ensure it's an array

                        return (
                          <>
                            {/* Display existing files with "View File" links and statuses */}
                            {otherDetails.length > 0 && (
                              <ul className="mt-2">
                                {otherDetails.map((file, index) => {
                                  // Extract filename from the file path
                                  const fileName = file.path.split("/").pop();

                                  // if (file.filestatus === "1") {
                                  //   fileStatusLabel = "✅ Approved";
                                  // } else if (file.filestatus === "2") {
                                  //   fileStatusLabel = "❌ Rejected";
                                  // } else if (file.filestatus === "0") {
                                  //   fileStatusLabel = "⏳ Not Verified";
                                  // }

                                  return (
                                    <li
                                      key={index}
                                      className="d-flex align-items-center"
                                    >
                                      <a
                                        href={`${baseUrl}${file.path}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {fileName}
                                      </a>{" "}
                                    </li>
                                  );
                                })}
                              </ul>
                            )}

                            {/* Display newly uploaded files (before submission) */}
                            {fileArray.length > 0 && (
                              <ul className="mt-2 list-group">
                                {fileArray.map((file, index) => (
                                  <li
                                    key={index}
                                    className="list-group-item d-flex justify-content-between align-items-center"
                                  >
                                    <span>{file.name}</span>
                                    <Button
                                      color="danger"
                                      size="sm"
                                      onClick={() => {
                                        const updatedFiles = fileArray.filter(
                                          (_, i) => i !== index
                                        );
                                        onChange(updatedFiles);
                                      }}
                                    >
                                      <i className="fa fa-trash"></i>{" "}
                                      {/* FontAwesome trash icon */}
                                    </Button>
                                  </li>
                                ))}
                              </ul>
                            )}
                          </>
                        );
                      }}
                    />
                  </Col>
                </Row>
              </FormGroup>

              {existingData?.indentform && (
                <FormGroup>
                  <Row className="align-items-center">
                    <Col md={4}>
                      <Label className="mb-0">Indent Form</Label>
                    </Col>
                    <Col md={8}>
                      <a
                        href={`${baseUrl}${existingData.indentform}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View Indent Form
                      </a>
                    </Col>
                  </Row>
                </FormGroup>
              )}
              <hr />
              {/* Rejection Reasons */}
              {Array.isArray(rejectionReasons) &&
                rejectionReasons.length > 0 && (
                  <div className="mt-3 p-3 bg-light border rounded m-5">
                    <table className="table table-bordered mt-2">
                      <thead>
                        <tr>
                          <th>Rejected By</th>
                          <th>Reject Reason</th>
                          <th>Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rejectionReasons.map((reason, index) => {
                          // Determine who rejected it
                          let rejectedBy = "Unknown";
                          if (reason.status === 2) {
                            rejectedBy = "Purchase Team";
                          }
                          if (reason.finalstatus === 2) {
                            rejectedBy = "Purchase Manager";
                          }

                          // Get rejection reason
                          const rejectionText =
                            reason.rejectstatus && reason.rejectstatus.trim()
                              ? reason.rejectstatus
                              : reason.rejectreason &&
                                reason.rejectreason.trim()
                              ? reason.rejectreason
                              : "No reason provided";

                          // Format the rejectedAt date
                          const rejectedAtText = reason.rejectedAt
                            ? new Date(reason.rejectedAt).toLocaleString()
                            : "Date not available";

                          return (
                            <tr key={index}>
                              <td className="text-danger">{rejectedBy}</td>
                              <td className="text-danger">
                                <strong>{rejectionText}</strong>
                              </td>
                              <td className="text-danger">{rejectedAtText}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}

              {/* Display Rejection Reason if finalstatus == 0 and status == 2 */}
              {parseInt(status) === 2 && rejectionReason && (
                <div className="mt-3 p-3 bg-light border rounded text-dark">
                  <strong>Rejection by purchase team:</strong> {rejectionReason}
                </div>
              )}

              {/* Display Rejection Status if finalstatus == 2 and status == 1 */}
              {parseInt(finalstatus) === 2 && rejectionstatus && (
                <div className="mt-3 p-3 bg-light border rounded text-dark">
                  <strong>Rejection by Purchase manager:</strong>{" "}
                  {rejectionstatus}
                </div>
              )}
            </Form>
          </div>
        </Card>
      </Col>
    </>
  );
}
